/**
 * @@author        j0Shi
 * @@date          2020.01.10
 * @@desc          Resets all api http status values when leaving or updating routes. Mandatory to use wherever logic is based on api status
 * @@usedby        Object
                   Search
                   Offer
 */
export default {
  beforeRouteLeave(to, from, next) {
    this.rahsMixin_resetApiHttpStatus();
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.rahsMixin_resetApiHttpStatus();
    next();
  },
  methods: {
    rahsMixin_resetApiHttpStatus() {
      const store = this.$store;
      Object.keys(store.state.app.apiHttpStatus).forEach((type) => {
        store.commit('SET_APP_APIHTTPSTATUS', { type, status: 200 });
      });
    },
  },
};
